import { Component, OnDestroy, OnInit, forwardRef, Inject, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
//import { ActivatedRoute } from '@angular/router';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';
//import { isNotNullOrUndefinedOrEmpty } from '@infrastructure/objectUtils';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';


@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class NotificationsComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy {

  @Input("cardData")
  public cardData: models.NotificationsVM = {} as models.NotificationsVM;

  @Input("beneficiaryID")
  public beneficiaryID: number;


  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  public isServiceOrFunerary: boolean;

  public preFilledProperties: PreFilledProperty[] = [];
  constructor(
    @Inject(BeneficiaryListTableEditComponent) public parent: Component,
    private modalService: ModalService,
    private beneficiaryValuesService: BeneficiaryValuesService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    this.cardData = (<any>parent)._cardData;

    this.isServiceOrFunerary = this.parent['parent']['parentWorkflow']?.workflowInstance.StepSender.SenderQualification?.isServiceOrFunerary?.toString() == 'true';
  }


  ngOnInit(): void {
    const fieldArray = ["emailNotification"];
    this.preFilledProperties =
      this.beneficiaryValuesService
        .getPreFilledProperties(this.beneficiaryID, this.cardData, fieldArray);


  }

  ngOnDestroy(): void {
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }

  public isStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return result;
  }

  public IsStateIndeferida(): boolean {
    const result = this.beneficiariesStateService
      .getStateIndeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return result;
  }
}
